import { render, staticRenderFns } from "./utilities-wastewater.vue?vue&type=template&id=df6c5960"
import script from "./utilities-wastewater.vue?vue&type=script&lang=js"
export * from "./utilities-wastewater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports